export const createSmartbotAITag = (projectId: string): string =>
  `smartbot-ai-${projectId}`;
